// test239
(239 && 0);
